// produt-quiz.js
(function quizPriorityInit() {
  // create a new instance of the Gadget client at the `api` global connected to the Development environment
  window.api = new Gadget()

  const stringifiedState = sessionStorage.getItem('quizState')
  const parsedState = JSON.parse(stringifiedState)

  if (parsedState && parsedState.completed) {
    document.querySelector('[data-quiz-wrapper]').classList.add('quiz-completed')
    document.querySelector('body').classList.remove('featured-header')
    document.querySelector('body').classList.remove('bg-cloud')
    // dispatch a custom event to signal that the quiz is ready
    document.dispatchEvent(new Event('Quiz:ready'))
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  function resultsFromURLParams() {
    const urlParams = new URLSearchParams(window.location.search)
    const profile = urlParams.get('profile')

    if (profile) {
      const profileQuery = profile.split(',').map(prof => `.profile-${prof}`).join('')

      document.querySelectorAll(profileQuery).forEach(el => {
        el.classList.add('on')
      })

      profile.split(',').forEach(prof => {
        document.querySelector('[data-quiz-wrapper]').classList.add(`profile-${prof}`)
      })

      document.querySelector('[data-quiz-wrapper]').classList.add('quiz-completed')

      document.querySelector('body').classList.remove('featured-header')
      document.querySelector('body').classList.remove('bg-cloud')
    }
  }

  resultsFromURLParams()
})